import {
  BMComponentsType,
  BMPrimitives,
  BMText,
  useBMTheme,
} from "@traveloka/district-bloom";
import { StyleSheet } from "react-native";
import { View } from "../../../components";
import { useMobileContentResource } from "../../../core/resource/MobileResourceProvider";
import { formatMessage } from "../../../utils";

export default function MobileGenericFooter() {
  const { CorporateMobileFooter } = useMobileContentResource();
  const { BMComponents } = useBMTheme();
  const styles = createStyle(BMComponents);

  return (
    <View style={styles.footer} align="center" justify="center">
      <BMText ink="BMStyleTextInkSecondary">
        {formatMessage(CorporateMobileFooter.footerText, {
          year: new Date().getFullYear(),
        })}
      </BMText>
    </View>
  );
}

const createStyle = (BMComponents: BMComponentsType) =>
  StyleSheet.create({
    footer: {
      paddingHorizontal: BMPrimitives.BMSize.md,
      paddingTop: BMPrimitives.BMSize.lg,
      paddingBottom: BMPrimitives.BMSize.xl,
      backgroundColor: BMComponents.BMUiBannerBgcolorGrey,
      marginTop: "auto",
    },
  });
